import { render } from "./Section.vue?vue&type=template&id=4698b604&scoped=true"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"

import "./Section.vue?vue&type=style&index=0&id=4698b604&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4698b604"

export default script